<mat-toolbar class="p-0 mat-elevation-z1">

  <div class="toolbar-element flex w-full h-full flex-row justify-start items-center content-center">

    <div class="flex grow shrink-0 basis-auto flex-row justify-end items-center content-center">

      @if (!hiddenNavbar && !rightNavbar) {
        <button mat-icon-button class="navbar-toggle-button lg:hidden"
          (click)="toggleSidebarOpen('navbar')">
          <mat-icon class="text-secondary">menu</mat-icon>
        </button>
      }

      @if (!hiddenNavbar && !rightNavbar) {
        <div class="toolbar-separator lg:hidden"></div>
      }

      @if (horizontalNavbar) {
        <div class="flex flex-row justify-start items-center content-center">
          <div class="logo ml-2">
            <img class="logo-icon" [src]="_cdkConfigService.logo">
          </div>
        </div>
      }
      <!-- ALTERADO PELA PGE-RS: removida a ROLE -->
      <cdk-barra-pesquisa class="mr-1 ml-1 pesquisa-rapida" (inputText)="search($event)"></cdk-barra-pesquisa>
    </div>

    <div class="flex flex-row grow-0 shrink basis-auto justify-start items-center content-center">
      <div class="avatar-element">
        <button mat-button [matMenuTriggerFor]="userMenu"
          class="user-button">
          <div class="flex flex-row justify-center items-center content-center shrink-1">
            @if (!!userProfile?.imgPerfil?.conteudo === false) {
              <img class="avatar mr-0 sm:mr-2 h-full w-40" src="assets/images/avatars/User.png"
                >
            }
            @if (!!userProfile?.imgPerfil?.conteudo === true) {
              <img class="avatar mr-0 sm:mr-2 h-full w-40" [src]="userProfile.imgPerfil.conteudo|safeResourceUrl"
                >
            }
            <!-- ALTERADO PELA PGE-RS: adicionado primeira letra do último sobrenome. -->
            <span class="username mr-3 xs:hidden">{{userProfile?.nome.split(' ')[0] + ' ' + userProfile?.nome.split(' ').slice(-1)[0][0] + '.'}}</span>
            <mat-icon class="text-base xs:hidden" style="font-size: 24px !important;">keyboard_arrow_down</mat-icon>
          </div>
        </button>

        <mat-menu #userMenu="matMenu" [overlapTrigger]="false">

          <button mat-menu-item (click)="goConfiguracoes()">
            <mat-icon>account_circle</mat-icon>
            <span>Configurações</span>
          </button>

          <button mat-menu-item (click)="goLogout()">
              <mat-icon>exit_to_app</mat-icon>
              <span>Sair</span>
          </button>

        </mat-menu>
      </div>

      @if (!hiddenNavbar && rightNavbar) {
        <div class="toolbar-separator xs:hidden"></div>
      }

      <!-- ALTERADO PELA PGE-RS: adicionada opção para recarregar a tela -->
      <div class="toolbar-separator xs:hidden"></div>
      <button mat-icon-button 
        title="Recarregar o sistema SUPP" 
        class="mr-1 ml-1 quick-panel-toggle-button"
        onclick="window.location.href = window.location.href.split('?')[0] + '?cacheBust=' + new Date().getTime();">
          <mat-icon>loop</mat-icon>          
      </button>

      <div class="toolbar-separator xs:hidden"></div>

      <button mat-icon-button
        class="mr-1 ml-1 quick-panel-toggle-button"
        aria-label="Assinadores"
        aria-hidden="false"
        [matMenuTriggerFor]="menuAssinadores">
        <mat-icon aria-hidden="false" matTooltip="Assinadores" [matBadge]="assinadores.length" matBadgePosition="above after"
          [matBadgeColor]="assinadores.length ? 'primary' : 'warn'">
          lock
        </mat-icon>
      </button>
      <mat-menu #menuAssinadores="matMenu" class="menuNotificacao" [overlapTrigger]="false" xPosition="before">
        @if (assinadores.length) {
          <div class="notification-header">
            <div>
              <span class="title">Assinadores</span>
            </div>
          </div>
        }
        @if (assinadores.length) {
          <mat-list>
            @for (assinador of assinadores; track assinador; let i = $index; let len = $count) {
              <mat-list-item>
                <div class="notification-item" (click)="$event.stopPropagation(); setAssinadorSelecionado(assinador)">
                  <p style="cursor: pointer; margin: 15px 0 15px 10px; text-align: initial;"
                    [innerHTML]="assinador.hostName">
                  </p>
                  @if (assinador.selecionado) {
                    <div class="actions">
                      <mat-icon class="mat-18" title="Selecionado" (click)="$event.stopPropagation()">done</mat-icon>
                    </div>
                  }
                </div>
              </mat-list-item>
              @if (i !== len-1) {
                <mat-divider></mat-divider>
              }
            }
          </mat-list>
        } @else {
          <p class="textoMenu">Não há assinadores</p>
        }
      </mat-menu>

      <div class="toolbar-separator xs:hidden"></div>

      <button mat-icon-button
        class="mr-1 ml-1 quick-panel-toggle-button"
        aria-label="Notificações"
        aria-hidden="false"
        [matMenuTriggerFor]="menuNoticacoes"
        (click)="loadNotificacoes()">
        @if (carregandoNotificacao) {
          <mat-icon>
            <mat-spinner color="primary" diameter="20"></mat-spinner>
          </mat-icon>
        }
        @if (!carregandoNotificacao) {
          <mat-icon aria-hidden="false" matTooltip="Notificações" [matBadge]="notificacoesCount" matBadgePosition="above after"
            [matBadgeColor]="notificacoesCount ? 'warn' : 'primary'"
            (click)="reload()">
            notifications
          </mat-icon>
        }
      </button>
      <mat-menu #menuNoticacoes="matMenu" class="menuNotificacao" [overlapTrigger]="false" xPosition="before">
        @if (notificacoes.length) {
          <div class="notification-header">
            <div>
              <span class="title">Notificações</span>
              @if (checkedNotifications.length) {
                <span class="actions">
                  {{ this.checkedNotifications.length }}
                  <mat-icon class="mat-18" (click)="$event.stopPropagation()" [matMenuTriggerFor]="menuNoticacoesDetail">
                    more_vert
                  </mat-icon>
                  <mat-menu #menuNoticacoesDetail="matMenu" xPosition="before">
                    <mat-list>
                      <mat-list-item>
                        <button mat-menu-item (click)="marcarSelecionadosComoLido()">
                          <span>Marcar como lido</span>
                        </button>
                      </mat-list-item>
                      <mat-list-item>
                        <button mat-menu-item (click)="removerSelecionados()">
                          <span>Remover</span>
                        </button>
                      </mat-list-item>
                    </mat-list>
                  </mat-menu>
                </span>
              }
            </div>
            <div class="actions">
              <mat-icon class="mat-18" title="Marcar como lido" (click)="marcarTodasComoLida()">done_all</mat-icon>
              <mat-icon class="mat-18" title="Remover" (click)="excluirTodasNotificaoes()">delete</mat-icon>
              <mat-icon class="mat-18" title="Histórico de notificações" (click)="goNotificacoes()">history</mat-icon>
            </div>
          </div>
        }
        @if (notificacoes.length) {
          <mat-list>
            @for (notificacao of notificacoes; track notificacao.id; let i = $index; let len = $count) {
              <mat-list-item [class.non-readed]="!notificacao.dataHoraLeitura">
                @if (getNotificacaoContext(notificacao)?.id) {
                  <div class="notification-item" (click)="$event.stopPropagation()">
                    <mat-checkbox color="primary" (change)="checkNotification($event.checked, notificacao)"></mat-checkbox>
                    <div class="data-hora">
                      <div>{{notificacao.criadoEm?.toJSDate() | date: 'dd/MM/yy HH:mm':'-0300'}}</div>
                    </div>
                    <p [innerHTML]="notificacao.conteudo | titleCasePipe" (click)="sendToTarget(notificacao);">
                    </p>
                    <div class="actions">
                      <mat-icon class="mat-18" title="Abrir" (click)="sendToTarget(notificacao)">search</mat-icon>
                      <mat-icon class="mat-18" title="Abrir em outra aba" (click)="$event.stopPropagation(); openNewTab(notificacao)">open_in_new</mat-icon>
                      @if (getNotificacaoContext(notificacao)?.componente_digital_id) {
                        <mat-icon class="mat-18" title="Download" (click)="$event.stopPropagation(); download(notificacao)">cloud_download</mat-icon>
                        <mat-icon class="mat-18" title="Download direto" (click)="$event.stopPropagation(); downloadDireto(notificacao)">file_download</mat-icon>
                      }
                      @if (!notificacao.dataHoraLeitura) {
                        <mat-icon class="mat-18" title="Marcar como lida" (click)="$event.stopPropagation(); toggleLida(notificacao)">done</mat-icon>
                      }
                      <mat-icon class="mat-18" title="Remover" (click)="$event.stopPropagation(); removerNotificacao(notificacao)">delete</mat-icon>
                    </div>
                  </div>
                }
                @if (!getNotificacaoContext(notificacao)?.id) {
                  <div class="notification-item" (click)="$event.stopPropagation()">
                    <mat-checkbox color="primary" (change)="checkNotification($event.checked, notificacao)"></mat-checkbox>
                    <div class="data-hora">
                      <div>{{notificacao.criadoEm?.toJSDate() | date: 'dd/MM/yy HH:mm':'-0300'}}</div>
                    </div>
                    <p [innerHTML]="notificacao.conteudo | titleCasePipe">
                    </p>
                    <div class="actions">
                      @if (!notificacao.dataHoraLeitura) {
                        <mat-icon class="mat-18" title="Marcar como lida" (click)="$event.stopPropagation(); toggleLida(notificacao)">done</mat-icon>
                      }
                      <mat-icon class="mat-18" title="Remover" (click)="$event.stopPropagation(); removerNotificacao(notificacao)">delete</mat-icon>
                    </div>
                  </div>
                }
              </mat-list-item>
              @if (i !== len-1 && !notificacao.dataHoraLeitura) {
                <mat-divider></mat-divider>
              }
            }
          </mat-list>
        } @else {

          @if (carregandoNotificacao) {
            <div class="flex justify-center p-3">
              <mat-icon>
                <mat-spinner color="primary" diameter="20"></mat-spinner>
              </mat-icon>
            </div>
          } @else {
            <div class="actions-sem-not" >
              <p class="textoMenu">Não há notificações</p>
              <mat-icon class="mat-18" title="Histórico de notificações" (click)="goNotificacoes()">history</mat-icon>
            </div>
          }

        }
      </mat-menu>

      @if (!hiddenNavbar && rightNavbar) {
        <div class="toolbar-separator xs:hidden"></div>
      }

      <div class="toolbar-separator xs:hidden"></div>

      <button mat-icon-button
        id="help"
        class="mr-1 ml-1 quick-panel-toggle-button2"
        (click)="toggleSidebarOpen('ajudaPanel')"
        aria-label="Ajuda">
        <mat-icon matTooltip="Ajuda">live_help</mat-icon>
      </button>

      <div class="toolbar-separator xs:hidden"></div>

      <!-- COMENTADO PELA PGE-RS, issue: https://gitlab01.pgers.intra.rs.gov.br/supp/supp-administrativo-frontend/-/issues/259 
      <button mat-icon-button
        class="mr-1 ml-1 quick-panel-toggle-button2"
        (click)="toggleChatPanel()"
        aria-label="Mensagem">
        @if (carregandoChat) {
          <mat-icon>
            <mat-spinner color="primary" diameter="20"></mat-spinner>
          </mat-icon>
        }
        @if (!carregandoChat) {
          <mat-icon matTooltip="Chat" aria-hidden="false"
            [matBadge]="totalChatMensagensNaoLidas" matBadgePosition="above after"
            [matBadgeColor]="totalChatMensagensNaoLidas ? 'warn' : 'primary'">
            chat
          </mat-icon>
        }
      </button>
      -->

      @if (!hiddenNavbar && rightNavbar) {
        <div class="toolbar-separator xs:hidden"></div>
      }

      <div class="toolbar-separator xs:hidden"></div>

      @if ((!this._cdkSidebarService.getSidebar('quickPanel').isLockedOpen || this._cdkSidebarService.getSidebar('quickPanel').folded)
        && operacoesProcessando === 0) {
        <button mat-icon-button
          class="mr-1 ml-1 quick-panel-toggle-button3"
          (click)="toggleQuickPanel()"
          aria-label="Operações">
          <mat-icon matTooltip="Últimas Operações">format_list_bulleted</mat-icon>
        </button>
      }

      @if ((!this._cdkSidebarService.getSidebar('quickPanel').isLockedOpen || this._cdkSidebarService.getSidebar('quickPanel').folded)
        && operacoesProcessando > 0) {
        <div style="width: 43px !important; max-width: 43px !important; min-width: 43px !important;" class="quick-panel-toggle-button3 mat-icon-button flex justify-center items-center content-center"
          matTooltip="Processando {{operacoesPendentes}}/{{operacoesProcessando}} item(s)..."
          (click)="toggleQuickPanel()">
          <mat-spinner class="m-2" diameter="24"></mat-spinner>
        </div>
      }
    </div>

  </div>
  @if (titulo === 'Inicia Tour') {
    <div>
      <shepherd></shepherd>
    </div>
  }
</mat-toolbar>
